import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;


const getFirstWeightEntryList = (page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/first_weight_entry/', {
        headers: authHeader(), params: {
            deleted: 0,
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering,
        }
    });
};

const getFirstWeightEntryListByDieId = (dieId, page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/first_weight_entry/', {
    
        
        headers: authHeader(), params: {
            die: dieId,
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering
        }
    });
};

const getArchiveFirstWeightEntryList = (page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/first_weight_entry/?deleted=1', {
        headers: authHeader(), params: {
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering,
        }
    });
};

const getFirstWeightEntryDetails = (dieId) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/first_weight_entry-details/', {
        headers: authHeader(), params: {
            die: dieId
        }
    });
};


const getFirstWeightEntryById = (id) => {
    return axios.get(API_URL + '/api/' + API_VERSION + `/first_weight_entry/${id}`, {
        headers: authHeader()
    });
};
const addFirstWeightEntry = (formData) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/first_weight_entry/`,
        formData, // Payload for the request body
        { headers: authHeader() }, // Authentication header
    );
};
const updateFirstWeightEntry = (id, formPayload) => {
    return axios.patch(
        `${API_URL}/api/${API_VERSION}/first_weight_entry/${id}/`, // Include the die group's ID in the URL
        formPayload, // Payload for the request body
        { headers: authHeader() }, // Authentication header
    );
};
const deleteFirstWeightEntry = (id) => {
   
    return axios.delete(
        `${API_URL}/api/${API_VERSION}/first_weight_entry/${id}/`,
        { headers: authHeader() }, // Authentication header
      );
};
const unArchiveFirstWeightEntryRecord = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/first_weight_entry/${id}/unarchive/`, // Include the die group's ID in the URL
        {}, // Pass an empty object if no data needs to be sent
        { headers: authHeader() } // Authentication header
    );
};

const firstWeightEntryService = {
    getFirstWeightEntryList,
    getFirstWeightEntryListByDieId,
    getArchiveFirstWeightEntryList,
    getFirstWeightEntryDetails,
    getFirstWeightEntryById,
    addFirstWeightEntry,
    updateFirstWeightEntry,
    deleteFirstWeightEntry,
    unArchiveFirstWeightEntryRecord
};

export default firstWeightEntryService;
